// extracted by mini-css-extract-plugin
module.exports = {"header":"ViewPersonPublic_header__3XDFu"};